/**
 * @todo: Remove usage of this file, user `@irati/types` directly instead
 */

import {PaymentProvider, PaymentStatus, PaymentOrderStatus, PaymentCurrencyType} from "@irati/types"

export {PaymentProvider, PaymentStatus, PaymentOrderStatus, PaymentCurrencyType}

/** @note: This does not directly map to auto-gen yet */
export enum WalletType {
  User = "personal",
  Rewards = "rewards"
}
